import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  ShieldAlert,
  ArrowLeft,
  RefreshCw,
  Lock,
  UserCheck,
} from "lucide-react";

export default function LoginFailed() {
  return (
    <div className="min-h-screen bg-cream">
      <div className="mx-auto flex min-h-screen max-w-7xl items-center justify-center px-6 py-16 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.35 }}
          className="w-full max-w-2xl rounded-[2rem] border border-ink/10 bg-white p-8 shadow-sm md:p-12"
          data-testid="login-failed-page"
        >
          <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-peach">
            <ShieldAlert
              size={38}
              className="text-hotpink"
              strokeWidth={2.4}
            />
          </div>

          <p className="mt-8 text-center text-xs font-bold uppercase tracking-[0.25em] text-hotpink">
            Login Failed
          </p>

          <h1 className="mt-3 text-center font-display text-4xl tracking-tighter md:text-5xl">
            We couldn't sign
            <br />
            you in.
          </h1>

          <p className="mx-auto mt-5 max-w-xl text-center text-ink/65">
            Your authentication couldn't be completed. This may happen if your
            session expired, the login request was interrupted, or your account
            isn't fully configured yet.
          </p>

          <div className="mt-10 rounded-3xl border border-ink/10 bg-cream p-6">
            <p className="text-sm font-semibold text-ink">
              Things to check
            </p>

            <ul className="mt-4 space-y-3 text-sm text-ink/65">
              <li className="flex gap-3">
                <UserCheck
                  size={16}
                  className="mt-0.5 flex-none text-hotpink"
                />
                Make sure you're logging in with the correct Instagram Business
                account.
              </li>

              <li className="flex gap-3">
                <Lock
                  size={16}
                  className="mt-0.5 flex-none text-hotpink"
                />
                Verify that your Facebook Page is linked to your Instagram
                Business account.
              </li>

              <li className="flex gap-3">
                <RefreshCw
                  size={16}
                  className="mt-0.5 flex-none text-hotpink"
                />
                Refresh the page and try signing in again.
              </li>
            </ul>
          </div>

          <div className="mt-10 flex flex-col gap-4 md:flex-row">
            <Link
              to="/login"
              data-testid="retry-login-btn"
              className="cta-glow inline-flex flex-1 items-center justify-center gap-2 rounded-full bg-sunset-gradient px-6 py-3 text-sm font-semibold text-white"
            >
              <RefreshCw size={16} />
              Try Again
            </Link>

            <Link
              to="/"
              data-testid="home-btn"
              className="inline-flex flex-1 items-center justify-center gap-2 rounded-full border border-ink/10 bg-white px-6 py-3 text-sm font-semibold text-ink hover:bg-ink/5"
            >
              <ArrowLeft size={16} />
              Back to Home
            </Link>
          </div>

          <p className="mt-8 text-center text-xs text-ink/50">
            Still having trouble? Contact Checkout DM support and we'll help you
            get connected.
          </p>
        </motion.div>
      </div>
    </div>
  );
}